import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import { AuthService, Principal, PrincipalService } from '@elderbyte/ngx-auth'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { MatDivider } from '@angular/material/divider'
import { AsyncPipe } from '@angular/common'
import {
  ElderShellComponent,
  ElderToolbarColumnDirective,
  ElderLanguageSwitcherComponent,
  ElderShellSideLeftDirective,
  ElderAppHeaderComponent,
  ElderExpandToggleButtonComponent,
  ElderTogglePanelTriggerDirective,
  ElderTogglePanelComponent,
  ElderTogglePanelPrimaryDirective,
  ElderNavListComponent,
  ElderNavLinkComponent,
  ElderTogglePanelSecondaryDirective,
  ElderAppearanceSettingsComponent,
  ElderRailNavDirective,
  ElderShellStaticNavSlotDirective,
  ElderTranslatePipe,
} from '@elderbyte/ngx-starter'
import { MainNavMenuComponent } from './main-nav-menu/main-nav-menu.component'

class MenuItem {
  constructor(
    public icon: string,
    public name: string,
    public link: string
  ) {}
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ElderShellComponent,
    ElderToolbarColumnDirective,
    ElderLanguageSwitcherComponent,
    ElderShellSideLeftDirective,
    ElderAppHeaderComponent,
    ElderExpandToggleButtonComponent,
    ElderTogglePanelTriggerDirective,
    ElderTogglePanelComponent,
    ElderTogglePanelPrimaryDirective,
    ElderNavListComponent,
    ElderNavLinkComponent,
    MatDivider,
    ElderTogglePanelSecondaryDirective,
    AsyncPipe,
    ElderTranslatePipe,
    MainNavMenuComponent,
    ElderAppearanceSettingsComponent,
    ElderRailNavDirective,
    ElderShellStaticNavSlotDirective,
  ],
})
export class AppComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly logger = LoggerFactory.getLogger('AppComponent')

  public version = environment.version

  private principalService = inject(PrincipalService)

  private authService = inject(AuthService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Account                                                                 *
   *                                                                         *
   **************************************************************************/

  public get accountUrl(): string {
    return environment.issuerUrl + '/account'
  }

  public get principal$(): Observable<Principal> {
    return this.principalService.principalObservable
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {}

  public login(): void {
    this.authService.goToLogin(location.pathname)
  }

  public logout(): void {
    this.authService.logout()
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
